import {Device} from 'platform/foundation';
import {AppLanguage} from 'platform/locale';

import {toPairs} from 'ramda';
import {isNotNilOrEmpty} from 'ramda-adjunct';

import {EXTRA_PAINT_THICKNESS_ATTRIBUTES_COUNT} from '../constants/constants';
import {createPaintThicknessAttributes} from '../utils/createPaintThicknessAttributes';
import {Exterior} from './getExterior';

export function getPaintThicknessAttributes({
  paintData,
  language,
  showEmptyFields,
  device,
}: {
  paintData: NonNullable<Exterior>['paintData'];
  language: AppLanguage;
  showEmptyFields: boolean;
  device: Device;
}) {
  const maybeSlicedPaintData =
    device === 'mobile'
      ? toPairs(paintData)
      : toPairs(paintData).slice(-EXTRA_PAINT_THICKNESS_ATTRIBUTES_COUNT);

  const attributes = createPaintThicknessAttributes(maybeSlicedPaintData, language);

  if (showEmptyFields) {
    return attributes;
  }

  return attributes.filter((item) => isNotNilOrEmpty(item.flag.text));
}
